//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import {
  IContentLibraryItem,
  IDeserializedContentLibraryItem,
} from '@apis/content-library/contentLibraryApiModel';
import { IMediaTypeOverlayIconProps } from '@components/atoms/overlay-icon/MediaTypeOverlayIcon';
import { InstagramPostType } from '@models/InstagramPostType';

export const getContentLibraryItemMediaType: (
  contentLibraryItem: IContentLibraryItem | IDeserializedContentLibraryItem,
) => IMediaTypeOverlayIconProps['type'] = (contentLibraryItem) => {
  if (
    contentLibraryItem.socialDetails?.instagramPostType ===
    InstagramPostType.Story
  ) {
    return 'story';
  } else if (contentLibraryItem.metadata.videoSource) {
    return 'video';
  } else {
    return 'image';
  }
};
